"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageStyle = void 0;
var _styledComponents = require("../../styled-components.js");
//
// Images
// --------------------------------------------------

var imageStyle = exports.imageStyle = function imageStyle() {
  return (0, _styledComponents.css)(["vertical-align:middle;"]);
};